import { Navigate, Route, Routes } from "react-router-dom";
import { SecuredRoute } from "./components/Authentication/SecuredRoute";
import { AppLayout } from "./components/AppLayout";
import ServicesPage from "./pages/Services";
import ServiceStatusPage from "./pages/ServiceStatus";
import SubServiceStatusPage from "./pages/SubServiceStatus";
import { Configuration } from "./pages/Configuration";
import { EnvironmentProvider } from "./context/EnvironmentContext";
import { Authenticator } from "@aws-amplify/ui-react";
import CircuitBreakersPage from "./pages/CircuitBreakers";
import DeploymentsPage from "./pages/Deployments";

function App() {
    return (
        <EnvironmentProvider>
            <Authenticator.Provider>
                <AppLayout>
                    <Routes>
                        <Route path="/" element={<SecuredRoute />}>
                            <Route path="/" element={<ServicesPage />} />
                        </Route>
                        <Route path="/circuitbreakers" element={<SecuredRoute />}>
                            <Route path="/circuitbreakers" element={<CircuitBreakersPage />} />
                        </Route>
                        <Route path="/deployments" element={<SecuredRoute />}>
                            <Route path="/deployments" element={<DeploymentsPage />} />
                        </Route>
                        <Route path="/service/:id" element={<SecuredRoute />}>
                            <Route
                                path="/service/:id"
                                element={<ServiceStatusPage />}
                            />
                        </Route>
                        <Route
                            path="/service/:id/sub-service/:service"
                            element={<SecuredRoute />}
                        >
                            <Route
                                path="/service/:id/sub-service/:service"
                                element={<SubServiceStatusPage />}
                            />
                        </Route>
                        <Route
                            path="/settings/configuration"
                            element={<SecuredRoute />}
                        >
                            <Route
                                path="/settings/configuration"
                                element={<Configuration />}
                            />
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </AppLayout>
            </Authenticator.Provider>
        </EnvironmentProvider>
    );
}
export default App;